// extracted by mini-css-extract-plugin
export default {"suggestions":"MovieSuggestions_suggestions__NswO9","suggestions__options":"MovieSuggestions_suggestions__options__+8V5a","active":"MovieSuggestions_active__euoKU"};